import { EventListener } from './event-listener.interface';

/**
 * Generic description of an event implementation capable of remembering the last emitted value.
 */
export interface PersistingEventListener<TEmission> extends EventListener<TEmission> {
  readonly value: TEmission;
}
